// image
import { InternalAppType } from "types/branding";
import { getBrandingAssetsForInternalAppType } from "utils/brandingUtils";

// ==============================|| LOGO PNG ||============================== //

const LogoMain = ({
  src,
  reverse,
  internalAppType,
}: {
  src?: string;
  reverse?: boolean;
  internalAppType?: InternalAppType;
}) => {
  /*
   * Original size:
   * width="118" height="35"
   * We keep the visual height but allow responsive width
   */
  const assets = getBrandingAssetsForInternalAppType(internalAppType);
  
  return (
    <img
      src={src || assets.logo}
      alt={src ? "Custom logo" : assets.alt}
      style={{
        maxHeight: 35,
        maxWidth: 210, // prevents sidebar overflow
        width: "auto",
        height: "auto",
        objectFit: "contain", // preserve ratio
        display: "block",
      }}
    />
  );
};

export default LogoMain;
